
(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npResizer', ['$document', 'resizeService', function ($document, resizeService) {
        return {
            restrict: 'A',
            scope: {
                resizerMin: '=',
                isCompare: '='
            },
            link: function (scope, element, attr) {

                scope.finalWidthChanged = 0;
                scope.isTouched = false;

                element.on('mousedown', function (event) {
                    event.preventDefault();
                    $document.on('mousemove', getHeightChanged);
                    $document.on('mouseup', mouseup);
                });

                element.on('touchstart', function (event) {
                    event.preventDefault();
                    scope.isTouched = true;
                    $document.on('touchmove', getHeightChanged);
                    $document.on('touchend', touchend);
                });

                function getHeightChanged(event) {
                    var _pageX = scope.isTouched ? event.originalEvent.changedTouches[0].pageX : event.pageX;
                    scope.finalWidthChanged = _pageX > scope.resizerMin ? _pageX : scope.resizerMin;
                    element.css({
                        'width': (scope.finalWidthChanged + 8) + 'px',
                        'z-index': 1000
                    });
                };

                function mouseup() {
                    $document.unbind('mousemove', getHeightChanged);
                    $document.unbind('mouseup', mouseup);
                    updateChanged();
                };

                function touchend() {
                    $document.unbind('touchmove', getHeightChanged);
                    $document.unbind('touchend', touchend);
                    updateChanged();
                    scope.isTouched = false;
                };

                function updateChanged() {
                    if (scope.isCompare || scope.finalWidthChanged > 320) {
                        resizeService.resizeToChangedSize(scope.finalWidthChanged, scope.isCompare);
                    } else {
                        //removeChanged();
                        resizeService.resizeToOrginalSize();
                    }
                };

                function applyChanged() {
                    angular.element(elementId.sidebarWrapper).css({
                        'width': scope.finalWidthChanged + 'px'
                    });

                    element.css({
                        'width': (scope.finalWidthChanged + 8) + 'px',
                        'z-index': 999
                    });

                    var screenWidth = $document.width();
                    if (screenWidth > 980) {
                        angular.element(elementClass.tabTable).css({
                            'padding-left': (scope.finalWidthChanged - 320) + 'px'
                        });

                        angular.element(elementClass.frontPageCustomArea).css({
                            'padding-left': (scope.finalWidthChanged - 320) + 'px'
                        });
                    }
                };

                function removeChanged() {
                    angular.element(elementId.sidebarWrapper).removeAttr('style');
                    angular.element(elementClass.tabTable).removeAttr('style');
                    angular.element(elementClass.frontPageCustomArea).removeAttr('style');
                    element.removeAttr('style');
                };
            }
        };
    }]);
})();